export const registrationFormTH = {
  announcement_of_qualify_candidates: "ประกาศสิทธิ์สอบ",
  announcement_of_qualify_candidates_date: "วันที่ประกาศสิทธิ์สอบ",
  announcement_of_examination_result: "ประกาศผลสอบคัดเลือก",
  announcement_date: "วันที่ประกาศ",
  all_information_of_will_disappear: (ctx) => `ข้อมูลการตั้งค่าจะ "${ctx.named('name')}" จะถูกลบทั้งหมด`,
  applicants: "จำนวนผู้สมัคร",
  application_available: "เปิดรับ",
  application_confirmation_notify: "ผู้สมัครสามารถยืนยันสิทธิ์ / สละสิทธิ์ ได้ตั้งแต่วันที่ประกาศผล จนถึงวันสิ้นสุดการยืนยันสิทธิ์",
  application_detail: "ข้อมูลการรับสมัคร",
  application_fee: "ค่าธรรมเนียมการสมัคร",
  application_form: "ฟอร์มการรับสมัคร",
  application_opening_date: "วันที่เปิดรับสมัคร",
  application_closing_date: "วันที่ปิดรับสมัคร",
  application_period: "ช่วงเวลาการรับสมัคร",
  application_title: "ชื่อรอบการสมัคร",
  application_link: "ลิงค์การรับสมัคร",
  application_grade_level: "ระดับชั้น",
  candidate_list: "รายชื่อผู้สมัคร",
  confirmed: "ยืนยันสิทธิ์เข้าศึกษา",
  copy_of_id_card: 'สำเนาบัตรประชาชนนักเรียน',
  copy_of_home_registration: 'สำเนาทะเบียนบ้านนักเรียน',
  copy_of_birth_certificate: 'สำเนาสูติบัตร',
  copy_of_name_change: 'สำเนาหลักฐานการเปลี่ยนชื่อ - สกุล',
  copy_of_legitimation_of_child: 'สำเนาใบจดทะเบียนเป็นบุตรบุญธรรม',
  medical_certificate: 'ใบรับรองแพทย์',
  copy_of_transcript: 'สำเนาระเบียนแสดงผลการเรียน (ปพ.1) ด้านหน้าและด้านหลัง',
  portfolio: 'แฟ้มสะสมผลงาน (Portfolio)',
  curriculum_and_grade_level: "แผนการเรียน และระดับชั้นที่รับสมัคร",
  curriculum_available_on_application: "ไม่มีแผนการเรียนที่เปิดรับสมัคร",
  curriculum_info: "หากต้องการแก้ไข หรือเพิ่ม แผนการเรียน จัดการได้ที่เมนู ปีการศึกษา > แผนการเรียน",
  deadline_of_confirmation: "วันสิ้นสุดการยืนยันสิทธิ์",
  deadline_of_confirmation_info: "ผู้สมัครสามารถยืนยันสิทธิ์เข้าศึกษาได้ตั้งแต่วันที่ประกาศผล จนถึง\nวันสิ้นสุดการยืนยันสิทธิ์",
  deadline_of_payment: "ชำระเงินภายในวันที่",
  documents_for_application: "เอกสารหลักฐานการสมัคร",
  exam_date: "วันสอบคัดเลือก",
  exam_date_alt: "วันที่สอบ",
  edit: "แก้ไขข้อมูล",
  exam_period: "เวลาสอบ",
  first_exam_period: "เวลาสอบช่วงที่ 1",
  second_exam_period: "เวลาสอบข่วงที่ 2",
  first_round: "รอบตัวจริง",
  reserve_round: "รอบตัวสำรอง",
  first_round_type: "ตัวจริง",
  reserve_round_type: "ตัวสำรอง",
  received_fee: "ค่าธรรมเนียมที่ได้",
  remove_selected_application_form: "ต้องการลบข้อมูลการรับสมัคร",
  search_by_academic_year: "ค้นหา โดยปีการศึกษา",
  search_by_curriculum: "ค้นหา แผนการเรียน",
  set_up_application_form: "ตั้งค่าการรับสมัคร",
  test_venue: "สถานที่สอบ",
  test_venue_information: "สถานที่ที่ระบุ จะแสดงบนบัตรประจำตัวเข้าห้องสอบ",
  the_initiation_day: "วันมอบตัว",
  initiation_day: "วันที่มอบตัว",
  total_required_amount: (ctx) => `จำนวนที่รับทั้งหมด ${ctx.named('total')} คน`,
  please_create_an_online_application_form: "กรุณาสร้าง\nฟอร์มสมัครออนไลน์",
  qualified: "มีสิทธิ์สอบ",
  download_applicants: "ดาวน์โหลดรายชื่อ",
  list_of_applicants: "รายชื่อผู้สมัคร",
  initiation_complete: "มอบตัวสำเร็จ",
  search_by_applicants_name: "ค้นหาโดย ชื่อนักเรียน / เลขบัตร / ประเภท",
  result: "ผลการคัดเลือก",
  list_of_exam_authorize: "รายชื่อผู้มีสิทธิ์สอบ",
  list_of_qualified: "รายชื่อผู้ผ่านการคัดเลือก",
  list_of_applicant_ticket: "บัตรประจำตัวเข้าห้องสอบ",
  suggestion_status_description_remark: "รายชื่อที่มีสถานะมอบตัวสำเร็จเท่านั้น ที่จะสามารถนำเข้าฐานข้อมูลนักเรียนของ Schooney ได้",
  suggestion_1_start: "กดปุ่ม",
  suggestion_1_end: "ที่รายชื่อผู้สมัคร เพื่อดูรายละเอียดใบสมัครหรือแก้ไขสถานะ",
  suggestion_2: "คำอธิบายสถานะ",
  suggestion_2_1: "ลงทะเบียน : ผู้สมัครส่งใบสมัครสำเร็จ",
  suggestion_2_2: "กรณีมีค่าธรรมเนียมการสมัครจะมีสถานะ ดังนี้",
  suggestion_2_2_1: "รอการชำระเงิน : ผู้สมัครส่งใบสมัครแต่ยังรอการชำระเงิน",
  suggestion_2_2_2: "ชำระเงินสำเร็จ : ผู้สมัครส่งใบสมัครและชำระเงินสำเร็จ",
  suggestion_2_3: "มีสิทธิ์สอบ : ผู้สมัครผ่านเกณฑ์การสมัคร",
  suggestion_2_4: "ไม่มีสิทธิ์สอบ : ผู้สมัครไม่ผ่านเกณฑ์การสมัคร",
  suggestion_2_5: "รอการยืนยันสิทธิ์ : ผลการสอบคัดเลือกผ่านเกณฑ์ รอผู้สมัครยืนยันสิทธิ์การเข้าศึกษา",
  suggestion_2_6: "ยืนยันสิทธิ์ : ผลการสอบคัดเลือกผ่านเกณฑ์ และผู้สมัครยืนยันสิทธิ์การเข้าศึกษาสำเร็จ",
  suggestion_2_7: "สละสิทธิ์ : ผลการสอบคัดเลือกผ่านเกณฑ์ แต่ผู้สมัครสละสิทธิ์การเข้าศึกษา",
  suggestion_2_8: "มอบตัวสำเร็จ : ผู้สมัครเข้ามอบตัวและชำระค่าเทอมที่โรงเรียนสำเร็จ",
  suggestion_2_9: "ไม่ผ่านเกณฑ์ : ผลการสอบคัดเลือกไม่ผ่านเกณฑ์",
  suggestion_3: "หลังจากคัดเลือกผู้สมัครสำเร็จ สามารถตรวจสอบรายชื่อผู้สมัครที่จะนำเข้าฐานข้อมูลนักเรียนได้ที่เมนู",
  remove_list_of_applicants: "ต้องการลบรายชื่อผู้สมัคร",
  remove_list_of_applicants_description: (ctx) => `รายชื่อผู้สมัคร "${ctx.named('name')}" จะถูกลบทั้งหมดและไม่สามารถนำข้อมูลกลับมาได้`,
  remove_list_of_application_description: (ctx) => `รายชื่อผู้สมัคร "${ctx.named('name')}" จำนวนผู้สมัคร ${ctx.named('total')} คน จะถูกลบทั้งหมด และไม่สามารถนำข้อมูลกลับมาได้`,
  create_application_form: "สร้างฟอร์มการรับสมัคร",
  edit_application_form: "แก้ไขฟอร์มการรับสมัคร",
  form_setting: "ตั้งค่าฟอร์ม",
  fee_amount: "จำนวนเงิน",
  enable_to_fill_an_amount_of_application_fee: "เปิดใช้งานเพื่อระบุจำนวนเงินที่นักเรียนต้องชำระ",
  document_name: "ชื่อเอกสาร",
  announcement_of_examination_result_for_first_round: "ประกาศผลสอบคัดเลือกรอบตัวจริง",
  announcement_of_examination_result_for_reserve_round: "ประกาศผลสอบคัดเลือกรอบตัวสำรอง",
  online_application_form: "ฟอร์มการรับสมัครออนไลน์",
  create_application_link: "สร้างลิงค์การรับสมัคร",
  save_draft: "บันทึกฉบับร่าง",
  save_and_update_link: "บันทึกและอัปเดตลิงค์การรับสมัคร",
  information: "ข้อมูลทั่วไป",
  do_you_want_to_save_information: "ต้องการบันทึกข้อมูลหรือไม่ ?",
  information_not_be_saved: "คุณยังไม่ทำการบันทึกข้อมูล",
  close_without_save: "ปิดโดยไม่บันทึก",
  failed_to_created_an_application_form: "สร้างฟอร์มการรับสมัครออนไลน์ไม่สำเร็จ",
  view_the_application_form: "ดูฟอร์มการรับสมัคร",
  empty_list_of_application_form: "กรุณาสร้างฟอร์มการสมัคร\nที่เมนู \"ตั้งค่าการรับสมัคร\" ก่อน",
  add_to_the_table: "เพิ่มลงในตาราง",
  created_an_application_form: "สร้างฟอร์มการรับสมัครออนไลน์สำเร็จ",
  created_an_application_form_description: " เมื่อถึงเวลาการเปิดรับสมัคร คัดลองลิงค์ฟอร์มใบสมัครออนไลน์\nและนำไปวางบนเว็ปไซต์ของโรงเรียนหรือเว็ปไซต์ประกาศการเปิดรับสมัคร\nเพื่อให้ผู้สมัครกรอกข้อมูลส่งมายังระบบ Schooney",
  copy_application_link: "คัดลอกลิงค์",
  created_an_application_form_remark: "รายละเอียดเพิ่มเติม",
  created_an_application_form_remark_1: "หากถึงช่วงเวลาการเปิดรับสมัครผู้สมัครจะสามารถกรอกข้อมูล\nเพื่อส่งใบสมัคร มายังระบบ Schooney โดยสามารถดูข้อมูลได้ที่เมนู \"รายชื่อผู้สมัคร\"",
  created_an_application_form_remark_2: "ตรวจสอบข้อมูลในถูกต้อง เนื่องจากฟอร์มการสมัครจะไม่สามารถแก้ไขได้\nเมื่อ Link ถูก เปิดการใช้งาน",
  created_an_application_form_remark_3: "หลังจากสิ้นสุดเวลาการรับสมัคร Link ฟอร์มการสมัครจะถูกปิดการใช้งาน โดยอัตโนมัติ",
  document_name_already_exist_please_change: "ชื่อเอกสารซ้ำ กรุณาระบุชื่อใหม่",
  cannot_identify_academic_year: "ไม่สามารถระบุปีย้อนหลังได้",
  application_title_duplicate: "ชื่อรอบซ้ำ กรุณาตั้งชื่อใหม่",
  transferred: "สำเร็จ",

  please_fill_academic_year: "ระบุปีการศึกษา",
  please_fill_application_title: "ระบุชื่อรอบการสมัคร",
  please_fill_application_opening_date: "ระบุวันเปิดรับสมัคร",
  please_fill_application_opening_time: "ระบุเวลาเปิดรับสมัค",
  please_fill_application_closing_date: "ระบุวันปิดรับสมัคร",
  please_fill_application_closing_time: "ระบุเวลาปิดรับสมัคร",
  please_fill_an_amount_of_application_fee: "ระบุจำนวนเงินเป็นตัวเลข",
  please_fill_deadline_of_payment: "ระบุวันชำระเงินวันสุดท้าย",
  please_select_application_deadline_date_after_application_available : "กรุณาเลือกวันที่มากกว่า วันเปิดรับสมัคร",
  please_select_date_after_application_available: "กรุณาเลือกวันที่มากกว่า วันเปิดรับสมัคร",
  please_select_date_before_application_deadline: "กรุณาเลือกวันที่น้อยกว่า วันปิดรับสมัคร",
  please_select_date_after_application_deadline : "กรุณาเลือกวันที่มากกว่า วันปิดรับสมัคร",
  please_fill_the_document_name: "ระบุชื่อเอกสาร",
  please_fill_the_document_name_or_delete_the_document_if_not_want_to_create : "ระบุชื่อเอกสาร / ลบเอกสารหากไม่ต้องการสร้างใหม่",
  please_fill_exam_date: "ระบุวันสอบ",
  please_fill_exam_time: "ระบุเวลาสอบ",
  please_fill_announcement_date: "ระบุวันประกาศสิทธิ์สอบ",
  please_fill_announcement_time: "ระบุเวลาประกาศสิทธิ์สอบ",
  please_fill_test_venue: "ระบุสถานที่สอบ เช่น ชื่อโรงเรียน / อาคาร",
  please_fill_exam_date_for_display: "ระบุวันที่สอบเพื่อแสดงบนบัตรประจำตัวเข้าห้องสอบ",
  please_select_date_after_announcement_of_qualify_date : "กรุณาเลือกมากกว่า วันประกาศสิทธิ์สอบ",
  please_select_time_after_start_time : "กรุณาเลือกมากกว่า เวลาเริ่ม",
  please_fill_exam_result_announcement_date: "ระบุวันประกาศผลสอบคัดเลือก",
  please_select_date_after_exam_date : "กรุณาเลือกวันที่มากกว่า วันสอบคัดเลือก",
  please_fill_exam_result_announcement_time: "ระบุเวลาประกาศผลสอบคัดเลือก",
  please_fill_deadline_confirmation_date: "ระบุวันสิ้นสุดการยืนยันสิทธิ์",
  please_select_date_after_exam_result_date : "กรุณาเลือกวันที่มากกว่า วันประกาศผลสอบคัดเลือก",
  please_fill_announcement_of_examination_result_for_first_round : "ระบุวันประกาศผลสอบคัดเลือกรอบตัวจริง",
  please_fill_announcement_of_examination_result_for_first_round_time : "ระบุเวลาประกาศผลสอบคัดเลือกรอบตัวจริง",
  please_fill_announcement_of_examination_result_for_reserve_round : "ระบุวันประกาศผลสอบคัดเลือกรอบตัวสำรอง",
  please_fill_announcement_of_examination_result_for_reserve_round_time : "ระบุเวลาประกาศผลสอบคัดเลือกรอบตัวสำรอง",
  please_select_date_after_result_announcement_date: "กรุณาเลือกวันที่มากกว่า วันประกาศผลสอบคัดเลือก",
  please_fill_initiation_day: "ระบุวันที่มอบตัว",
  please_select_date_after_announcement_of_examination_result_for_first_round : "กรุณาเลือกวันที่มากกว่า วันสิ้นสุดการยืนยันสิทธิ์รอบตัวจริง วันสุดท้าย",
  please_select_date_after_announcement_of_examination_result_for_reserve_round : "กรุณาเลือกวันที่มากกว่า วันสิ้นสุดการยืนยันสิทธิ์รอบตัวสำรอง วันสุดท้าย",
  please_fill_all_of_required_field_to_save_information: "หากต้องการบันทึกข้อมูล กรุณากดปิดหน้าต่างนี้ และระบุข้อมูลที่จำเป็นให้ครบก่อน",
  please_correct_application_form_link_must_create_before_application_available : "แก้ไขข้อมูลฟอร์มการรับสมัครใหม่อีกครั้ง\nลิงค์ต้องถูกสร้างขึ้นก่อนวันเปิดรับสมัครเท่านั้น",
  required_amount: "จำนวนที่เปิดรับ",
  please_fill_required_amount: "ระบุจำนวนที่เปิดรับ",
  please_fill_number: "ระบุจำนวนเต็ม",
  please_select_grade_level_and_curriculum_available_on_application: "เลือกระดับชั้นและแผนการเรียน\nที่เปิดรับสมัคร",
  please_fill_number_less_than_digit: "ระบุจำนวนเต็มไม่เกิน 8 หลัก",

  placeholder_application_title: "เช่น รอบมัธยมศึกษา",
  placeholder_datepicker: "วว / ดด / ปป",
  placeholder_test_venue: "ระบุชื่อโรงเรียนหรืออาคารสอบ",
  placeholder_grade_level: "เลือกระดับชั้น",
  placeholder_curriculum: "เลือกแผนการเรียน",
  placeholder_fill_required_amount: `ระบุจำนวนนักเรียนที่รับ`,
  errorOpeningDateIsOver: "ไม่สามารถสร้าง Link ณ วันนี้ / ย้อนหลังได้ กรุณาเลือกวันเปิดรับสมัครใหม่"

}

export const registrationFormEN = {
  announcement_of_qualify_candidates: "Announcement of qualify applicants",
  announcement_of_qualify_candidates_date: "Announcement of qualify applicants date",
  announcement_of_examination_result: "Announcement of \nexamination result",
  announcement_date: "Announcement date",
  all_information_of_will_disappear: (ctx) => `All information of "${ctx.named('name')}" will disappear `,
  applicants: "Applicants",
  application_available: "Application available",
  application_confirmation_notify: "Applicants can confirm / waiver the rights since announcement date until deadline of confirmation",
  application_detail: "Application detail",
  application_fee: "Application fee",
  application_form: "Application form",
  application_opening_date: "Application available",
  application_closing_date: "Application deadline",
  application_period: "Application period",
  application_title: "Application title",
  application_link: "Application link",
  application_grade_level: "Grade level",
  candidate_list: "Candidate list",
  confirmed: "Confirmed",
  copy_of_id_card: 'Copy of ID card',
  copy_of_home_registration: 'Copy of home registration',
  copy_of_birth_certificate: 'Copy of birth certificate',
  copy_of_name_change: 'Copy of Certificate of Name Changed',
  copy_of_legitimation_of_child: 'Copy of legitimation of child',
  medical_certificate: 'Medical certificate',
  copy_of_transcript: 'Copy of transcript',
  portfolio: "Portfolio",
  curriculum_and_grade_level: "Curriculum and Grade Level",
  curriculum_available_on_application: "Curriculum available on application",
  curriculum_info: "For edit or add curriculum go to menu Academic year > Curriculum",
  deadline_of_confirmation: "Deadline of confirmation",
  deadline_of_confirmation_info: "Applicants can confirm the rights since announcement until deadline of confirmation",
  deadline_of_payment: "Deadline of payment",
  documents_for_application: "Documents for application",
  exam_date: "Exam Date",
  exam_date_alt: "Exam Date",
  edit: "Edit",
  exam_period: "Exam period",
  first_exam_period: "First exam period",
  second_exam_period: "Second exam period",
  first_round: "first round",
  reserve_round: "reserve round",
  first_round_type: "First round",
  reserve_round_type: "Reserve round",
  received_fee: "Received fee",
  remove_selected_application_form: "Remove selected application form",
  search_by_academic_year: "Search by Academic year",
  search_by_curriculum: "Search by curriculum",
  set_up_application_form: "Set up application form",
  test_venue: "Test venue",
  test_venue_information: "Test venue will display on application ID card",
  the_initiation_day: "The initiation day",
  initiation_day: "Date of initiation",
  total_required_amount: (ctx) => `Total required amount ${ctx.named('total')} person`,
  please_create_an_online_application_form: "Please create\nan online application form",
  qualified: "Qualified",
  download_applicants: "Download",
  list_of_applicants: "List of applicants",
  initiation_complete: "Initiation complete",
  search_by_applicants_name: "Search by Applicants name / ID number / Type",
  result: "Result",
  list_of_exam_authorize: "List of exam authorize",
  list_of_qualified: "List of qualified",
  list_of_applicant_ticket: "Application Tickets",
  suggestion_1_start: "Select",
  suggestion_1_end: "at \"List of applicants\" for more detail or edit",
  suggestion_2: "Status description",
  suggestion_2_1: "Register : applicants has submitted the application",
  suggestion_2_2: "In case of the school have an application fee, the status will be as follows:",
  suggestion_2_2_1: "Pending payment : applicants has submitted an application but not complete the payment",
  suggestion_2_2_2: "Payment completed : Applicants submit application and complete payment.",
  suggestion_2_3: "Qualified : Applicants pass the application criteria",
  suggestion_2_4: "Not qualified : Applicants do not pass the application criteria",
  suggestion_2_5: "Waiting for confirmation : Applicants pass the exam waiting to confirm the rights",
  suggestion_2_6: "Confirmed : Applicants pass the exam and confirmed the rights",
  suggestion_2_7: "Waiver : Applicants pass the exam but waiver the rights",
  suggestion_2_8: "Initiation complete : Applicants completed initiation and payment",
  suggestion_2_9: "Not passed : Applicants do not pass the exam",
  suggestion_status_description_remark: "Only applicants with successful initiation status can submit form to schooney system",
  suggestion_3: "After selection complete admin can check list of qualified applicants for submit to schooney system in",
  remove_list_of_applicants: "Remove List of applicants",
  remove_list_of_applicants_description: (ctx) => `List of applicants "${ctx.named('name')}" will disappear and can't undo the action`,
  remove_list_of_application_description: (ctx) => `List of applicants "${ctx.named('name')}" amount of applicants ${ctx.named('total')} persons will disappear and can't undo the action`,
  create_application_form: "Create application form",
  edit_application_form: "Edit application form",
  form_setting: "Form setting",
  fee_amount: "Amount",
  enable_to_fill_an_amount_of_application_fee: "Enable to fill an amount of application fee",
  document_name: "Document name",
  announcement_of_examination_result_for_first_round: "Announcement of examination result for first round",
  announcement_of_examination_result_for_reserve_round: "Announcement of examination result for reserve round",
  online_application_form: "Online application form",
  create_application_link: "Create application link",
  save_draft: "Save draft",
  save_and_update_link: "Save and update link",
  information: "Information",
  do_you_want_to_save_information: "Do you want to save information ?",
  information_not_be_saved: "Information not be saved",
  close_without_save: "Close without save",
  failed_to_created_an_application_form: "Failed to created an application form",
  view_the_application_form: "View the application form",
  empty_list_of_application_form: "Please create the application form\nin \"Set up application form menu\" first",
  add_to_the_table: "Add to the table",
  created_an_application_form: "Created an application form",
  created_an_application_form_description: " When application available, please copy application link\n and announcement on the website for applicants to register",
  copy_application_link: "Copy application linkation link",
  created_an_application_form_remark: "Remark",
  created_an_application_form_remark_1: "When application available, applicants will allow to register and submit form\n to schooney system and admin can check in \"List of applicants\" menu",
  created_an_application_form_remark_2: "Please check the information. The application form cannot be edited\n when link is activated.",
  created_an_application_form_remark_3: "After the deadline of application, application link will be inactive",

  document_name_already_exist_please_change: "Document name already exist please change",
  cannot_identify_academic_year: "Can't identify academic year",
  application_title_duplicate: "Application title already exist please change title",
  transferred: "Transferred",

  please_fill_academic_year: "Please fill academic year",
  please_fill_application_title: "Please fill application title",
  please_fill_application_opening_date: "Please fill application available",
  please_fill_application_closing_date: "Please fill application deadline",
  Please_fill_an_amount_of_application_fee: " Please fill an amount of application fee",
  please_fill_deadline_of_payment: "Please fill deadline of payment",
  please_select_application_deadline_date_after_application_available : "Please select application deadline date after application available",
  please_select_date_after_application_available: "Please select date after application available",
  please_select_date_before_application_deadline : "Please select date before application deadline",
  please_select_date_after_application_deadline : "Please select date after application deadline",
  please_fill_the_document_name: "Please fill the document name",
  please_fill_the_document_name_or_delete_the_document_if_not_want_to_create : "Please fill the document name / delete the document if not want to create",
  please_fill_exam_date: "Please fill exam date",
  please_fill_exam_time: "Please fill exam time",
  please_fill_announcement_date: "Please fill announcement date",
  please_fill_announcement_time: "Please fill announcement time",
  please_fill_test_venue: "Please fill test venue ex. name of school / building",
  please_fill_exam_date_for_display: "Please fill exam date",
  please_select_date_after_announcement_of_qualify_date : "Please select date after announcement of qualify date",
  please_select_time_after_start_time : "Please select time after start time",
  please_fill_exam_result_announcement_date: "Please fill announcement date",
  please_select_date_after_exam_date : "Please select date after exam date",
  please_fill_exam_result_announcement_time: "Please fill announcement time",
  please_fill_deadline_confirmation_date: "Please fill deadline of confirmation",
  please_select_date_after_exam_result_date : "Please select date after exam result date",
  please_fill_announcement_of_examination_result_for_first_round : "Please fill announcement date",
  please_fill_announcement_of_examination_result_for_first_round_time : "Please fill announcement time",
  please_fill_announcement_of_examination_result_for_reserve_round : "Please fill announcement date",
  please_fill_announcement_of_examination_result_for_reserve_round_time : "Please fill announcement time",
  please_select_date_after_result_announcement_date: "Please select date after result announcement date",
  please_fill_initiation_day: "Please fill initiation date",
  please_select_date_after_announcement_of_examination_result_for_first_round : "Please select date after deadline of confirmation",
  please_select_date_after_announcement_of_examination_result_for_reserve_round : "Please select date after deadline of confirmation",
  please_fill_all_of_required_field_to_save_information: "Please fill all of required field to save Information",
  please_correct_application_form_link_must_create_before_application_available : "Please correct application form\nlink must create before application available",
  required_amount: "Required amount",
  please_fill_required_amount: "Please fill required amount",
  please_fill_number: "Please fill number",
  please_select_grade_level_and_curriculum_available_on_application: "Please select grade level and curriculum\n available on application",
  please_fill_number_less_than_digit: (ctx) => `Please fill number not over ${ctx.named('digit')} digits`,

  placeholder_application_title: "Ex. High school",
  placeholder_datepicker: "dd / mm / yy",
  placeholder_test_venue: "Please fill test venue",
  placeholder_grade_level: "Select grade",
  placeholder_curriculum: "Select curriculum",
  placeholder_fill_required_amount: "Please fill required amount",
  errorOpeningDateIsOver: "Can not generate application link in/after application period. Please change date of application period"
}
